import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from "../services/auth";


const Protected = ({ children }) => {
  const [user, loading] = useAuth();
  const searchParams = new URLSearchParams(window.location.search);

  if (loading) return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '600px', width: '100%' }}>
      <CircularProgress />
    </Box>
  )
  if (!user) {
    if (searchParams.has("code")) {
      return <Navigate to={`/login${window.location.search}`} replace />;
    }

    return <Navigate to="/login" replace />;
  }

  return children;
};

export default Protected;
